import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const hasRegimeRejectedAudits = api(async function hasRegimeRejectedAudits(referenceId, type, version) {
    if (version === 0) return false
    return query(
        gql`
            query HasRegimeRejectedAudits($referenceId: String, $type: String, $version: Int) {
                hasRegimeRejectedAudits(referenceId: $referenceId, type: $type, version: $version)
            }
        `,
        { referenceId, type, version },
        {
            returns: "hasRegimeRejectedAudits",
        }
    )
})
